import React, { useState } from 'react';
import { IProcessManager } from '../../Interfaces/IProcessManager';
import {
  IProcessManagerAutomation,
  IProcessManagerAutomationEmailToExternal,
  IProcessManagerAutomationEmailToLegalClient,
  IProcessManagerAutomationLegalRequirementChange,
} from '../../Interfaces/IProcessManagerAutomation';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { IProcessManagerAutomationType } from '../../Interfaces/IProcessManagerAutomationType';
import {
  isPMAutomationEmailToExternal,
  isPMAutomationEmailToLegalClient,
  isPMAutomationLegalRequirementChange,
} from '../pm_helpers';
import { Delete } from '@mui/icons-material';
import { ILegalClient } from '../../Interfaces/ILegalClient';

interface IProps {
  automation: IProcessManagerAutomation;
  processManager: IProcessManager;
  automations: IProcessManagerAutomation[];
  setAutomations: Function;
  processManagerAutomationTypes: IProcessManagerAutomationType[];
  //
  legalClients: ILegalClient[];
  legalPhases: ILegalPhaseFullObject[];
  legalReqStates: ILegalRequirementState[];
  //
  setIsExpantedAutomations?: Function;
  /** Wenn gesetzt, wird der Delete-Button ausgeblendet — z. B. wenn der
   *  zugehoerige Tracker bereits getriggert hat (Zielsumme erreicht). */
  readOnly?: boolean;
}

export const PMAutomationsRow: React.FC<IProps> = ({
  automation,
  processManager,
  automations,
  setAutomations,
  processManagerAutomationTypes,
  legalClients,
  legalPhases,
  legalReqStates,
  setIsExpantedAutomations,
  readOnly = false,
}) => {
  const [editAutomation, setEditAutomation] = useState(automation);

  const handleRemove = () => {
    const filteredArray = [
      ...automations.filter(
        auto =>
          auto.idProcessManagerAutomation !==
          editAutomation.idProcessManagerAutomation
      ),
    ];

    if (setIsExpantedAutomations && filteredArray.length === 0) {
      setIsExpantedAutomations(false);
    }
    setAutomations([...filteredArray]);
  };

  return (
    <>
      <TableRow>
        <TableCell>
          {
            processManagerAutomationTypes.find(
              pmType =>
                pmType.idProcessManagerAutomationType ===
                editAutomation.idProcessManagerAutomationType
            )?.ProcessManagerAutomationType
          }
        </TableCell>
        <TableCell>
          {isPMAutomationEmailToLegalClient(editAutomation.data) &&
            (() => {
              const data =
                editAutomation.data as IProcessManagerAutomationEmailToLegalClient;
              const currentLegalClient = legalClients.find(
                legalClient => legalClient.idLegalClient === data.idLegalClient
              );
              return (
                <>
                  <i>{data.Subject}</i> an{' '}
                  {currentLegalClient === undefined ? (
                    <>Unbekannt</>
                  ) : (
                    `Mandant ${currentLegalClient.FirstName} ${currentLegalClient.LastName}`
                  )}
                </>
              );
            })()}
          {isPMAutomationEmailToExternal(editAutomation.data) &&
            (() => {
              const data =
                editAutomation.data as IProcessManagerAutomationEmailToExternal;

              return (
                <>
                  <i>{data.Subject}</i> an {`${editAutomation.data.Receiver}`}
                </>
              );
            })()}
          {isPMAutomationLegalRequirementChange(editAutomation.data) &&
            (() => {
              const data =
                editAutomation.data as IProcessManagerAutomationLegalRequirementChange;
              return (
                <>
                  Maßnahme{' '}
                  <i>
                    {legalPhases
                      .flatMap(phase => phase.LegalRequirementArray)
                      .find(
                        req =>
                          req.idLegalRequirement === data.idLegalRequirement
                      )?.LegalRequirement ?? 'Unbekannt'}
                  </i>{' '}
                  auf{' '}
                  <i>
                    {
                      legalReqStates.find(
                        reqState =>
                          reqState.idLegalRequirementState ===
                          data.idLegalRequirementState
                      )?.LegalRequirementState
                    }
                  </i>
                </>
              );
            })()}
        </TableCell>
        <TableCell>
          {!readOnly && (
            <IconButton size='small' onClick={handleRemove}>
              <Delete />
            </IconButton>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
